import { Routes, Route } from 'react-router-dom';
import { Suspense } from 'react';
import { AppLayout } from '@/components/layout/app';
import { SpinLoading } from '@/components/shared/loadings/spin';
import { MemberCardSheet } from '@/components/shared/sheets/member-card';
import { useAuthStore } from '@/lib/core/stores/useAuthStore';
import { SplashPage, ScreenPage, AuthRedirectPage, AuthAccessPage, DebugSfmcPage } from '@/pages';

export function AppRoutes() {
  const { accessToken, user, isAuthenticated, hasPermissions, isWelcomed, isSessionActive } = useAuthStore();

  const isLogged = accessToken && isAuthenticated && user;
  const isActive = isLogged && hasPermissions && isWelcomed && isSessionActive;

  return (
    <>
      <Routes>
        <Route path="/auth-redirect" element={<AuthRedirectPage />} />
        <Route path="/auth-access" element={<AuthAccessPage />} />
        <Route path="/debug/sfmc" element={<DebugSfmcPage />} />
        <Route
          path="/notifications/inbox"
          element={
            isLogged ? (
              <Suspense fallback={<SpinLoading spinnerClassName="border-primary" />}>
                <ScreenPage />
              </Suspense>
            ) : (
              <SplashPage />
            )
          }
        />

        {/* Home — immersive app shell with bottom tab bar */}
        <Route path="/" element={isActive ? <AppLayout /> : <SplashPage />}>
          <Route
            index
            element={
              <Suspense fallback={<SpinLoading spinnerClassName="border-primary" />}>
                {isActive ? <ScreenPage /> : <SplashPage />}
              </Suspense>
            }
          />
          <Route
            path=":slug/*"
            element={
              <Suspense fallback={<SpinLoading spinnerClassName="border-primary" />}>
                {isActive ? <ScreenPage /> : <SplashPage />}
              </Suspense>
            }
          />
        </Route>
      </Routes>

      {/* Global overlay sheets — rendered outside the route tree so they survive navigation */}
      {isActive && <MemberCardSheet />}
    </>
  );
}
